import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=71f5a222&lang=pug&"
import script from "./providers.vue?vue&type=script&lang=js&"
export * from "./providers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./providers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./providers.vue?vue&type=custom&index=1&blockType=router"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SiteProviders: require('/home/ubuntu/nuxt/bonkers/releases/20230924131341/components/site/providers.vue').default,SiteFeefo: require('/home/ubuntu/nuxt/bonkers/releases/20230924131341/components/site/feefo.vue').default})
